import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-2xl shadow-sm border border-stone-100 overflow-hidden ${className}`} data-id="element-264">
      <div className={noPadding ? '' : 'p-6 md:p-8'} data-id="element-265">{children}</div>
    </div>;
}